import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/Typography';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useAuthContext } from '@/data/hooks/auth';

interface UserSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Panneau « Mon compte » : identité de l'utilisateur et déconnexion. */
export const UserSheet = ({ open, onOpenChange }: UserSheetProps) => {
  const { t } = useTranslation();
  const { user, logout } = useAuthContext();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        aria-describedby={undefined}
        className='flex flex-col gap-6'
        data-testid='user-sheet'
      >
        <SheetHeader>
          <SheetTitle>{t('user.menu.account')}</SheetTitle>
        </SheetHeader>

        <div className='flex items-center gap-3'>
          <div className='flex size-12 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground'>
            {user.initials ? (
              <Typography variant='paragraphBold' className='text-primary-foreground'>
                {user.initials}
              </Typography>
            ) : (
              <FontAwesomeIcon icon={faUser} className='size-5' />
            )}
          </div>
          <div className='min-w-0'>
            <Typography variant='paragraphBold' color='foreground' className='truncate'>
              {user.fullName}
            </Typography>
            {user.job ? <Typography variant='paragraphSmall'>{user.job}</Typography> : null}
            {user.email ? (
              <Typography variant='paragraphMini' className='truncate'>
                {user.email}
              </Typography>
            ) : null}
            {user.service ? (
              <Typography variant='paragraphMini' className='truncate'>
                {user.service}
              </Typography>
            ) : null}
          </div>
        </div>

        <Separator />

        <Button variant='destructive' onClick={logout}>
          {t('user.menu.logout')}
        </Button>
      </SheetContent>
    </Sheet>
  );
};
